export interface IQuestionAnswer {
    question: string;
    answer: string;
    showing: boolean;
}

export const faq_model: Array<IQuestionAnswer> = [
    {
        question: 'question_one',
        answer: 'question_one_info',
        showing: true
    },
    {
        question: 'question_two',
        answer: 'question_two_info',
        showing: false
    },
    {
        question: 'question_three',
        answer: 'question_three_info',
        showing: false
    },
    {
        question: 'question_four',
        answer: 'question_four_info',
        showing: false
    },
    {
        question: 'question_five',
        answer: 'question_five_info',
        showing: false
    },
    {
        question: 'question_six',
        answer: 'question_six_info',
        showing: false
    },
    {
        question: 'question_seven',
        answer: 'question_seven_info',
        showing: false
    },
    {
        question: 'question_eigth',
        answer: 'question_eigth_info',
        showing: false
    }
];
